// @ts-nocheck fixme type annotations

import { LAST_CHAT_TIMESTAMP_KEY, LAST_CHAT_TIMESTAMP_CHANGED_EVENT } from "./constants";

(() => {
    // section accordion on help browse
    $(".hideable").each((index, parentElement) => {
        const hider = $(parentElement).find(".hideable-title");

        $(hider).click((event) => {
            if ($(parentElement).hasClass("closed")) {
                $(parentElement).removeClass("closed");
            } else {
                $(parentElement).addClass("closed");
            }

            if ($(parentElement).hasClass("hide-link-after-open")) {
                $(hider).addClass("hidden");
            }
            event.preventDefault();
        });
        return;
    });

    // open the "other" textarea when Other selected in
    $('input[name="feedback_choice"]').bind("change", (event) => {
        if (event.target.value === "other") {
            $(".expand-other-target").each((index, element) => $(element).removeClass("hidden"));
        } else {
            $(".expand-other-target").each((index, element) => $(element).addClass("hidden"));
        }
    });

    // change the visible items in the contact-us reasons list
    $(".help_contact__topic").bind("change", (event) => {
        const newSelection = event.target.value;
        let hasSelected = false;

        // can"t select until a topic is chosen
        $(".help_contact__reason").each((index, element) => $(element).removeAttr("disabled"));

        $(".help_contact__reason option").each((index, element) => {
            $(element).removeAttr("selected");
            if ($(element).data("topic") === newSelection || $(element).val() === "") {
                $(element).removeClass("hidden");
                if (!hasSelected) {
                    hasSelected = true;
                    $(element).prop("selected", "selected").change();
                }
            } else {
                $(element).addClass("hidden");
            }
        });
    });

    $(".help__feedback__no_choice").bind("change", (event) => {
        $('.help__feedback input[name="feedback_reason_submit"]').removeAttr("disabled");
    });

    $(".help_contact__reason").bind("change", (event) => {
        $('.help_contact__form input[name="feedback_reason_submit"]').removeAttr("disabled");
    });

    $("._get_help_btn_start_live_chat").click(function () {
        if (localStorage.getItem(LAST_CHAT_TIMESTAMP_KEY) == null) {
            localStorage.setItem(LAST_CHAT_TIMESTAMP_KEY, new Date().getTime());
            window.dispatchEvent(new CustomEvent(LAST_CHAT_TIMESTAMP_CHANGED_EVENT));
        }
    });
    // if the article is in widget
    $("#help__article__body__widget-id a").each((index, element) => {
        $(element).attr("target", "_parent");
    });
})();

export {};
